import React from "react";

import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import useAuth from "../../routes/login/AuthContext";
import { NetworkSearchInput } from "../NetworkSearchInput";
import { NetworksSelectInput } from "../NetworksSelectInput";

export const NetworkInput = () => {
  const { isSuperAdmin } = useAuth();

  return (
    <Grid container spacing={1} alignItems="center" wrap="nowrap">
      <Grid item>
        <Typography variant="body2">Network:</Typography>
      </Grid>
      <Grid item xs maxWidth={350}>
        {isSuperAdmin() && <NetworkSearchInput />}
        {!isSuperAdmin() && <NetworksSelectInput />}
      </Grid>
    </Grid>
  );
};
